// VoiceRecorder.js
// Simple voice recorder using Web Audio API
import React, { useRef, useState } from 'react';

const VoiceRecorder = ({ onTranscribe, disabled }) => {
  const [recording, setRecording] = useState(false);
  const [audioUrl, setAudioUrl] = useState(null);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);

  const startRecording = async () => {
    if (!navigator.mediaDevices) return alert('Audio recording not supported.');
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    mediaRecorderRef.current = new window.MediaRecorder(stream);
    audioChunksRef.current = [];
    mediaRecorderRef.current.ondataavailable = (e) => {
      if (e.data.size > 0) audioChunksRef.current.push(e.data);
    };
    mediaRecorderRef.current.onstop = () => {
      const blob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
      setAudioUrl(URL.createObjectURL(blob));
      // Send to backend for transcription
      if (onTranscribe) onTranscribe(blob);
    };
    mediaRecorderRef.current.start();
    setRecording(true);
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      setRecording(false);
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <button
        onClick={recording ? stopRecording : startRecording}
        disabled={disabled}
        style={{ background: recording ? '#e74c3c' : '#2ecc40', color: '#fff', border: 'none', borderRadius: 20, width: 40, height: 40 }}
        title={recording ? 'Stop Recording' : 'Start Voice Input'}
      >
        {recording ? '■' : '🎤'}
      </button>
      {audioUrl && <audio src={audioUrl} controls style={{ height: 24 }} />}
    </div>
  );
};

export default VoiceRecorder;
